import script from "./addButton.vue?vue&type=script&setup=true&lang=js"
export * from "./addButton.vue?vue&type=script&setup=true&lang=js"

import "./addButton.vue?vue&type=style&index=0&id=bf194050&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf194050"]])

export default __exports__